class ContentBlocksCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper }) => {
      this.Swiper = Swiper;
      window.addEventListener("resize", () => this._checkCarousel());
      this._checkCarousel();
    });
  }

  _checkCarousel() {
    if (window.matchMedia("(max-width: 1024px)").matches) {
      this._initCarousel();
    } else {
      this._destroyCarousel();
    }
  }

  _initCarousel() {
    if (this.swiper) return;

    this._toggleSwiperClasses(true);

    const swiperParams = {
      slidesPerView: "auto",
      speed: 400,
      spaceBetween: 16,
      centerInsufficientSlides: true,
    };

    this.swiper = new this.Swiper(this, swiperParams);
  }

  _destroyCarousel() {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
    this._toggleSwiperClasses(false);
  }

  _toggleSwiperClasses(add) {
    this.parentNode.querySelectorAll("[data-swiper-class]").forEach((el) => {
      el.classList.toggle(el.dataset.swiperClass, add);
    });
  }
}

if (!customElements.get("content-blocks-carousel")) {
  customElements.define("content-blocks-carousel", ContentBlocksCarousel);
}
